import type { CustomArrowProps } from '@ant-design/react-slick';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, IconButton as MuiIconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { FC, PropsWithChildren } from 'react';
import { getCompoundTestIdGenerator } from '~/utils/getCompoundTestIdGenerator';

type SlickNavButtonProps = PropsWithChildren<CustomArrowProps> & {
  id?: string;
};

const ButtonWrapper = styled(Box)(() => ({
  width: 'auto',
  height: 'auto',
  zIndex: 1,
}));

// react-slick types for the arrow props are incorrect, this workaround avoids errors in the console
// https://github.com/akiran/react-slick/issues/1195#issuecomment-390383615
const SlickButtonFix: FC<SlickNavButtonProps> = ({
  currentSlide: _currentSlide,
  slideCount: _slideCount,
  children,
  ...props
}) => <ButtonWrapper {...props}>{children}</ButtonWrapper>;

const IconButton = styled(MuiIconButton)(({ theme }) => ({
  boxShadow: theme.shadows[1],
  background: theme.palette.background.default,
}));

export const SlickPreviousButton = (props: SlickNavButtonProps) => {
  const { id, onClick } = props;
  const getCompoundTestId = getCompoundTestIdGenerator('slickPreviousButton');

  return (
    <SlickButtonFix {...props} style={{ left: -45 }}>
      <IconButton
        onClick={onClick}
        data-testid={getCompoundTestId()}
        id={id}
        aria-label="Previous slide"
        data-sp-button-label="Previous slide"
      >
        <ArrowBackIcon />
      </IconButton>
    </SlickButtonFix>
  );
};

export const SlickNextButton = (props: SlickNavButtonProps) => {
  const { id, onClick } = props;
  const getCompoundTestId = getCompoundTestIdGenerator('slickNextButton');

  return (
    <SlickButtonFix {...props}>
      <IconButton
        onClick={onClick}
        data-testid={getCompoundTestId()}
        id={id}
        aria-label="Next slide"
        data-sp-button-label="Next slide"
      >
        <ArrowForwardIcon />
      </IconButton>
    </SlickButtonFix>
  );
};
